import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "popMarketInfo",
  computed: {
    ...userVuex.mapState(["gameInfo"]),
    isRender() {
      return this.$parent.popMarketInfoShow;
    }
  },
  watch: {
    isRender: {
      handler(val) {
        if (val) {
          this.initPop();
        }
      },
      immediate: true
    }
  },
  methods: {
    initPop() {
      if (!this.$parent.popMarketInfoDom) {
        this.$parent.popMarketInfoDom = this.m_popDom(this.renderDom());
        this.gameApp.stage.addChild(this.$parent.popMarketInfoDom);
      }
      this.$parent.popMarketInfoDom.visible = true;
      this.$parent.popMarketInfoDom.zIndex = this.gameApp.stage.children.length + 11;
      this.anim_pop(this.$parent.popMarketInfoDom);
    },
    renderDom() {
      return {
        content: {
          pop_prompt: {
            content: {
              pop_prompt_mask: {
                content: this.c_createMask()
              },
              pop_main: {
                content: {
                  pop_prompt_con: {
                    content: {
                      pop_prompt_main_bg: {
                        content: this.sf_popBg({
                          width: this.screenWidth * 4 - 300,
                          height: 1700
                        })
                      },
                      pop_prompt_box: {
                        content: {
                          pop_prompt_main_title: {
                            content: "Market Information"
                          },
                          pop_prompt_main_content: {
                            content: {
                              text0: {
                                content: "1. Only miners rated 3 stars or above can list items for trade."
                              },
                              text2: {
                                content: "2. Only free coins from mining can be listed, and transactions must be in multiples of 10,000."
                              },
                              text3: {
                                content: "3. Sellers can withdraw items anytime unless a purchase is made, in which case the item is locked."
                              },
                              text4: {
                                content: "4. Locked items must be paid for within 3 minutes, or they are returned to the mark"
                              },
                              text5: {
                                content: `5.A transaction fee of ${this.gameInfo.marketFee * 100}% applies to all trades.`
                              }
                            }
                          }
                        }
                      },
                      pop_prompt_btns: this.m_btn({
                        id: "pop_prompt_btns",
                        content: {
                          pop_prompt_btns_main: {
                            content: {
                              pop_prompt_box_btn: {
                                content: {
                                  pop_prompt_btns_bg: {
                                    content: this.sf_btnBg({
                                      width: this.screenWidth * 4 - 540,
                                      height: 170
                                    }),
                                    styles: globalStyles.pop_prompt_btns_bg
                                  },
                                  pop_prompt_btns_text: {
                                    content: "OK",
                                    styles: globalStyles.pop_prompt_btns_text
                                  }
                                },
                                styles: globalStyles.pop_prompt_box_btn
                              }
                            }
                          }
                        },
                        styles: globalStyles.pop_prompt_btns
                      }, () => {
                        this.$parent.popMarketInfoDom.visible = false;
                        this.$emit("update:show", false);
                      })
                    }
                  }
                }
              }
            }
          }
        },
        globalStyles
      };
    }
  }
};
const globalStyles = {
  pop_prompt: {
    width: _v.screenWidth,
    height: _v.screenHeight,
    maxWidth: _v.screenWidth,
    maxHeight: _v.screenHeight,
    position: "leftTop",
    marginLeft: 0,
    disply: "block"
  },
  pop_prompt_mask: {
    position: "leftTop",
    width: _v.screenWidth,
    height: _v.screenHeight
  },
  pop_main: {
    position: "center",
    width: "100%",
    height: "100%"
  },
  pop_prompt_con: {
    width: _v.screenWidth - 82,
    height: 420,
    position: "center"
    // overflow: "hidden",
  },

  pop_prompt_main_bg: {
    position: "center",
    scale: 0.25
  },
  pop_prompt_box: {
    width: "100%",
    height: "100%",
    padding: 25
  },
  pop_prompt_main_title: {
    position: "centerTop",
    marginTop: 18,
    ..._v.fs_fontStyle({
      fz: 21,
      st: 2,
      ds: 1
    })
  },
  pop_prompt_main_content: {
    marginTop: 70,
    position: "centerTop",
    width: _v.screenWidth - 150
  },
  text0: {
    fontSize: 16,
    fontFamily: "pFont",
    fill: "#fff",
    wordWrap: true,
    wordWrapWidth: _v.screenWidth - 150,
    display: "line",
    paddingBottom: 3
  },
  text1: {
    fontSize: 15,
    fontFamily: "pFontM",
    fill: "#c4c4c4",
    wordWrap: true,
    wordWrapWidth: _v.screenWidth - 150,
    display: "line",
    lineHeight: 15
  },
  textA: {
    height: 16,
    display: "line",
    opacity: 0
  },
  text2: {
    fontSize: 15,
    fontFamily: "pFont",
    fill: "#fff",
    wordWrap: true,
    wordWrapWidth: _v.screenWidth - 150,
    display: "line",
    lineHeight: 15,
    paddingBottom: 3
  },
  text3: {
    fontSize: 16,
    fontFamily: "pFont",
    fill: "#fff",
    wordWrap: true,
    wordWrapWidth: _v.screenWidth - 150,
    display: "line"
  },
  text4: {
    fontSize: 16,
    fontFamily: "pFont",
    fill: "#fff",
    wordWrap: true,
    wordWrapWidth: _v.screenWidth - 150,
    display: "line"
  },
  text5: {
    fontSize: 16,
    fontFamily: "pFont",
    fill: "#fff",
    wordWrap: true,
    wordWrapWidth: _v.screenWidth - 150,
    display: "line"
  },
  pop_prompt_btns: {
    position: "centerBottom",
    overflow: "hidden",
    height: 45,
    width: "100%",
    marginBottom: 20
  },
  pop_prompt_box_btn: {
    width: "100%",
    height: "100%",
    position: "center"
  },
  pop_prompt_btns_bg: {
    scale: 0.25,
    position: "center"
  },
  pop_prompt_btns_text: {
    marginTop: -3,
    position: "center",
    ..._v.fs_fontStyle({
      fz: 18,
      st: 2,
      ds: 1
    })
  }
};